import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Box, Alert, InputAdornment, IconButton, Backdrop, CircularProgress } from '@mui/material';
import { login } from '../api/Auth';
import { useNavigate } from 'react-router-dom';
import SecureLS from 'secure-ls'
import { Icon } from '@iconify/react/dist/iconify.js';

const ls = new SecureLS({encodingType: 'aes'})

const Login = () => {
    const sanitizeInput = (input) => input.replace(/<[^>]*>?/gm, '');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const jwt = ls.get('jwt');
        if (jwt) {
            navigate('/admin/applicants');
        }
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await login(email, password)
            if (response.status !== 200) setError('Invalid email or password');
            navigate('/admin/applicants');
        } catch (error) {
            setError('Invalid email or password');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
        <Box sx={{ maxWidth: 400, margin: 'auto', textAlign: 'left', position: 'absolute', left: '50%', top: '40%', transform: 'translate(-50%, -50%)' }}>
            <Typography variant="h4" sx={{ mb: 2, textAlign: 'center' }}>APEX Admin Login</Typography>
            {error && (
                <Alert severity="error">
                    <Typography>{error}</Typography>
                </Alert>
            )}
            <form onSubmit={handleSubmit}>
                <TextField
                    fullWidth
                    autoFocus={true}
                    autoComplete="email"
                    margin="normal"
                    label="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(sanitizeInput(e.target.value))}
                />
                <TextField
                    fullWidth
                    margin="normal"
                    autoComplete="current-password"
                    label="Password"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label={showPassword ? 'Hide password' : 'Show password'}
                                    onClick={() => setShowPassword(!showPassword)}
                                    edge="end"
                                >
                                    {showPassword ? <Icon icon="mdi:eye-off-outline" /> : <Icon icon="mdi:eye-outline" />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                <Button type="submit" fullWidth variant="contained" color="primary" sx={{ mt: 2 }}>
                    Login
                </Button>
            </form>
        </Box>
        </>
    );
};

export default Login;
